import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { StatusChip } from '../ui';
import { BrandAuthorizationDesignation, designationDetail, designationLabel } from '../../utils/brandAuthorization';

interface BrandDesignationChipsProps {
  designations?: BrandAuthorizationDesignation[] | null;
  size?: 'small' | 'medium';
}

/**
 * The tiers a brand gives a store on top of its authorization level, one chip
 * each. A store's own claim reads neutral; anything Motzu read or recorded
 * reads info. The tooltip says where it came from and its dates.
 */
const BrandDesignationChips: React.FC<BrandDesignationChipsProps> = ({ designations, size = 'small' }) => {
  if (!designations?.length) return null;
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }} aria-label="Brand designations">
      {designations.map((d, index) => (
        <Tooltip key={`${d.source}-${d.tier}-${index}`} title={designationDetail(d)}>
          <span>
            <StatusChip
              label={designationLabel(d)}
              tone={d.source === 'self_declared' ? 'neutral' : 'info'}
              variant="outlined"
              size={size}
            />
          </span>
        </Tooltip>
      ))}
    </Box>
  );
};

export default BrandDesignationChips;
